<template>
    <div class="news-main-header row">
       <div class="news-search-wrapper col-12 col-md-4 pb-3">
        <p class="news-filter-header">Search by name</p>
        <search-small
          :placeholder="'Search by name'"
          @on-keyup="onSearchTermChanged"
          @on-enter="search"
          ref="newsSearchBox">
        </search-small>
       </div>
       <div class="news-date-picker-wrapper col-12 col-md-3 pb-3">
        <p class="news-filter-header">Date</p>
        <date-picker
          v-model="selectedDate"
          data-vv-validate-on="input"
          :label="'Select time frame'"
          :max-date="currentDate"
          :range="true"/>
       </div>
       <div class="news-category-wrapper col-12 col-md-3 pb-3">
        <p class="news-filter-header">Category</p>
        <div class="category-select">
            <model-list-select
              v-model="selectedCategory"
              option-value="value"
              option-text="text"
              :list="categories"
              placeholder="Select an option"
              @input="onCategoryChanged"
            />
        </div>
       </div>
       <div class="buttons-wrapper col-12 col-md-2 pb-3">
        <div class="search-button-wrapper">
          <div 
            class="homebase-btn-primary mt-4 ml-md-4" 
            @click="search">
            Search
          </div>
        </div>
        <div class="reset-button-wrapper">
          <a @click="reset">Clear</a>
        </div>
       </div>
    </div>
</template>
<script>

import api from "@/api";
import moment from "moment";
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelListSelect } from "vue-search-select";
import DatePicker from "@/components/homebase/DatePicker";
import SearchSmall from "@/components/homebase/SearchSmall";

export default {
    name: "news-feed-filters",
    components: {
        ModelListSelect,
        DatePicker,
        SearchSmall
    },
    created() {
      this.initializeNewsFilters();
    },
    data() {
        return {
          categories: [],
          textFilterValue: null,
          categoryFilterValue: null,
          selectedDate: null,
          selectedCategory: null,
          currentDate: null
        }
    },
    methods: {
      async initializeNewsFilters() {
        this.setCurrentDate();
        await this.setCategories();
      },
      setCurrentDate() {
        const dateStrFormat = "YYYY-MM-DD";
        this.currentDate = moment().format(dateStrFormat);
      },
      async setCategories() {
        let categoriesResponse = await api.getNewsCategories();
        categoriesResponse.data.data.newsCategories.forEach((category, index) => {
          this.categories.push({ value: index + 1, text: category });
        });
      },
      onSearchTermChanged(payload) {
        this.textFilterValue = payload.length > 0 ? payload : null;
      },
      onCategoryChanged() {
        this.categoryFilterValue = (this.selectedCategory) ? this.categories.filter(c => c.value === this.selectedCategory)[0].text : null;
      },
      search() {
        var filtersObject = { 
          name: this.textFilterValue, 
          startDate: this.selectedDate ? this.selectedDate.start : null, 
          endDate: this.selectedDate ? this.selectedDate.end : null,
          category: this.categoryFilterValue 
        };

        if(!this.isEmptyObject(filtersObject)) {
          this.$parent.$emit("onFilteredSearch", filtersObject);
        }
        else {
          this.$parent.$emit("onResetFilters");
        }
      },
      reset() {
        this.$parent.$emit("onResetFilters");
      },
      isEmptyObject(obj) {
        return Object.values(obj).every(val => !val);   
      }
    }
}
</script>
<style scoped>
.news-main-header {
  display: flex;
}
.news-filter-header {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.news-search-wrapper {
  width: 45%;
  padding-bottom: 36px;
}
.news-search-wrapper > div { 
  max-width: 100% !important;
}
.news-date-picker-wrapper {
  width: 45%;
}
.news-search-wrapper >>> .aone-table-search-input {
  font-size: 15px;
}
.category-select >>> .selection {
  border-radius: 10px;
  border: 1px solid #888888;
  padding: 12px 0px 12px 12px;
  font-size: 15px;
}
.category-select >>> .ui.search.dropdown>.text {
  bottom: 0;
  font-size: 15px;
  overflow: inherit;
}
.category-select >>> .ui.dropdown .menu>.item {
  font-size: 14px !important;
}
.buttons-wrapper {
  display: flex;
  gap: 25px;
}
.reset-button-wrapper  {
  min-width: 22px;
}
.reset-button-wrapper > a {
  font-family: artifaktElementBold;
  text-decoration: underline;
  font-size: 16px;
  line-height: 80px;
  max-height: 80px;
  text-align: center !important;
  cursor: pointer;  
}
.search-button-wrapper >>> .homebase-btn-primary {
  min-width: 130px !important;
}
@media (min-width: 576px) {
  .reset-button-wrapper {
    padding-top: 16px;
  }
}
@media (min-width: 768px) {
  .search-button-wrapper {
    margin-top: 11px;
  }
}
@media (max-width: 768px) {
  .reset-button-wrapper {
    padding-top: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/news/NewsFeedFilters.vue